module.exports = __webpack_public_path__ + "static/media/hand-point-up.2adf54f4.svg";